enum Locale {
  Fr = 'fr',
  En = 'en',
}

enum FullLocale {
  Fr = 'FR-fr',
  En = 'EN-en',
}

type Locales = { short: Locale; full: FullLocale };

export type { Locales };
export { FullLocale, Locale };
